import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'active-records-cta',
  templateUrl: './active-records-cta.component.html',
  styleUrls: ['./active-records-cta.component.scss'],
})
export class ActiveRecordsCtaComponent {
  @Output()
  ctaSkeleton: EventEmitter<void> = new EventEmitter();

  cta() {
    this.ctaSkeleton.emit();
  }
}
